const Provider = require("./Provider");
const PropTypes = require("prop-types");
const CrudStoreFabricator = require("stores/abstract/CrudStoreFabricator");
const inject = require("../decorators/Injector");
const shortid = require("shortid");
const {decodeObservable} = require("helpers/object")
const {computed, observable} = require("mobx");

@inject(["store", "context"])
class Resource extends Provider {

    @observable _errors = new Map();
    @observable _data = new Map();
    @observable _collection = new Map();

    @computed get errors(){
        return this._errors;
    }

    @computed get data(){
        return this._data;
    }

    @computed get collection(){
        return Array.from(this._collection.values());
    }

    /////////////////////////////////
    // Statics
    /////////////////////////////////

    static get propTypes() {
        return {
            name: PropTypes.string.isRequired,
            group: PropTypes.string,
            chain: PropTypes.bool,



            store: PropTypes.any,
            context: PropTypes.any,
            constraints: PropTypes.any,
            resource: PropTypes.string.isRequired,
            autoFetch: PropTypes.bool,
            frozen: PropTypes.array,
            group: PropTypes.string
        };
    }

    static get defaultProps() {
        return {
            group: null,
            chain: false,


            constraints: {},
            autoFetch: false,
            group: null,
            context: null,
            frozen: []
        };
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    get store() {
        let store = CrudStoreFabricator.create(this.props.resource, this.constraints, this.props.autoFetch, this.props.group, this.props.context);

        if (this.props.store && this.props.parent) {
            store.setParent(this.props.store);
        }

        if(this.props.context){
            store.setContext(this.props.context);
        }

        if(this.props.frozen.length > 0){
            store.replaceFrozen(this.props.frozen);
        }

        if(typeof(this.props.onActiveUpdated) === 'function'){
            store.onActiveUpdated(this.name+'_custom_callback', active => {
                console.log('active updated');
                this.props.onActiveUpdated(active);
            });
        }

        return store;
    }



    componentDidMount() {

        this.store.fetch().then(() => {
            console.log('GOT COLLETION', this.store.collection);
            let collection = decodeObservable(this.store.collection);
            let keyedCollection = collection.reduce((obj, item) => {
                obj[item.id] = item
                return obj
            }, {});
            this._collection.replace(keyedCollection);
            console.log('--------------',this._collection);
        })

        return;
        if (this.props.store) {
            if (this.props.parent && typeof(this.props.parent) === 'function') {
                this.props.store.onActiveUpdated(this.name, active => {
                    this.store.fetch();
                });
            }

        }
    }

    get name() {
        return ["provider", "store", this.resource, this.group].join('_');
    }

    get constraints() {
        return {
            [this.name]: () => {

                let constraints = {...this.props.constraints};

                if (this.props.store) {
                    if (this.props.parent && typeof(this.props.parent) === 'function') {
                        constraints = {...constraints, ...this.props.parent(this.props.store.active)};
                    }
                }

                return constraints;
            }
        };
    }

    get store() {
        let store = CrudStoreFabricator.create(this.props.name, this.constraints, this.props.autoFetch, this.props.group, this.props.context);

        return store;

        if (this.props.store && this.props.parent) {
            store.setParent(this.props.store);
        }

        if(this.props.context){
            store.setContext(this.props.context);
        }

        if(this.props.frozen.length > 0){
            store.replaceFrozen(this.props.frozen);
        }

        if(typeof(this.props.onActiveUpdated) === 'function'){
            store.onActiveUpdated(this.name+'_custom_callback', active => {
                console.log('active updated');
                this.props.onActiveUpdated(active);
            });
        }

        return store;
    }

    resolveStore() {

        let store = this.store;
        if (store !== null) {
            if (this.props.context) {
                store.setContext(this.props.context);
            }
            return store;
        }

        throw new Error('Failed to resolve and provide store');
    }

    get providerProps() {
        return {
            store: this,
            data: this.data,
            collection: this.collection,
            errors: this.errors
        };
    }

}

module.exports = Resource;